import { FCC, Row } from '../view.box';

export const GridNoRows: FCC = ({ children }) => {
	return <Row>{children}</Row>;
};
